import React from 'react';

import { PopularRecommendationQuery } from '../../../api/queries/recommendation.gql';
import PageQuery from '../../PageQuery';
import RecommendationBlock from '../RecommendationBlock';

const PopularRecommendation = () => (
  <PageQuery
    query={PopularRecommendationQuery}
    variables={{
      paginator: { limit: 4 },
    }}
  >
    {({ data }) => {
      const { edges } = data.popularRecommendation;
      return (
        <RecommendationBlock
          results={edges}
          title="Populair bij BNNVARA"
          recomType="populair"
        />
      );
    }}
  </PageQuery>
);

export default PopularRecommendation;
